export default function Patrocinadores() {
  const sponsors = [
    { name: "Patrocinador 1", logo: "https://i.ibb.co/placeholder1.png" },
    { name: "Patrocinador 2", logo: "https://i.ibb.co/placeholder2.png" },
    { name: "Patrocinador 3", logo: "https://i.ibb.co/placeholder3.png" },
    { name: "Patrocinador 4", logo: "https://i.ibb.co/placeholder4.png" },
    { name: "Patrocinador 5", logo: "https://i.ibb.co/placeholder5.png" },
  ];

  return (
    <section className="w-full py-8 md:py-12 bg-white">
      <div className="w-full px-4 md:px-8">
        <div className="text-center mb-6 md:mb-8">
          <span className="text-xs font-medium text-alvinegro-muted uppercase tracking-wider">
            Patrocinadores
          </span>
        </div>

        <div className="flex items-center justify-center gap-6 md:gap-12 flex-wrap">
          {sponsors.map((sponsor, index) => (
            <div
              key={index}
              className="w-24 h-12 md:w-32 md:h-16 bg-alvinegro-light rounded-lg flex items-center justify-center hover:bg-alvinegro-border transition-colors cursor-pointer"
            >
              <span className="text-xs font-medium text-alvinegro-muted">{sponsor.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}